<template>
  <img
    width="24px"
    height="24px"
    src="./download.svg"
    alt="Thunderbird send icon"
  />
</template>
